import _IconShareAlt from "@arco-design/web-react/icon/react-icon/IconShareAlt";
import _IconCalendarClock from "@arco-design/web-react/icon/react-icon/IconCalendarClock";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect, useState } from 'react';
import { ProcessApprovalRecord } from './ProcessApprovalRecord';
import BpmnViewer from '../BpmnViewer';
const TabPane = _Tabs.TabPane;
function ProcessTabs({
  id,
  processCode,
  processVersion,
  defaultActiveKey = '2'
}) {
  const [activeTab, setActiveTab] = useState('');
  useEffect(() => {
    if (id) {
      setActiveTab('1');
    } else {
      setActiveTab(defaultActiveKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return /*#__PURE__*/React.createElement("div", {
    className: "lx-process"
  }, /*#__PURE__*/React.createElement(_Tabs, {
    activeTab: activeTab,
    onClickTab: setActiveTab
  }, id ? /*#__PURE__*/React.createElement(TabPane, {
    key: "1",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconCalendarClock, {
      style: {
        fontSize: 16
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, "\u6D41\u7A0B\u5BA1\u6279\u8BB0\u5F55"))
  }, /*#__PURE__*/React.createElement(ProcessApprovalRecord, {
    id: id
  })) : null, /*#__PURE__*/React.createElement(TabPane, {
    key: "2",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconShareAlt, {
      style: {
        transform: 'rotate(90deg)'
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, "\u6D41\u7A0B\u56FE"))
  }, /*#__PURE__*/React.createElement(BpmnViewer, {
    id: id,
    processCode: processCode,
    processVersion: processVersion,
    style: {
      height: 300,
      minHeight: 300,
      width: '100%'
    }
  }))));
}
export { ProcessTabs };